
export default {
  name: 'ProductPrice',
  props: {
    currentPrice: {
      type: String,
      default: undefined,
    },
    oldPrice: {
      type: String,
      default: undefined,
    },
    isDiscounted: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: undefined,
    },
  },
}
